import { Injectable } from '@angular/core';
import { CompanyData, AccountValue, MonthlyAccounts, MonthlyCashFlow, MonthlyAccountState, } from '../model/accounting.model';
import { Observable } from 'rxjs';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { LocalStorageService } from '../../home/services/local-storage.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccountingService {

  constructor(
    private functions: AngularFireFunctions,
    private localStorageService: LocalStorageService
  ) {
  }

  getCompanyData = (): Observable<CompanyData> => {
    const callable = this.functions.httpsCallable('getCompanyData');
    return callable({
      accessToken: this.localStorageService.getAccessToken()
    });
  };

  getMonthlyAccountState = (yearMonths: string[]): Observable<MonthlyAccounts[]> => {
    const callable = this.functions.httpsCallable('getMonthlyAccountState');
    return callable({
      yearMonths,
      accessToken: this.localStorageService.getAccessToken()
    }).pipe(map((monthlyAccountState: MonthlyAccountState) => {
      return Object.getOwnPropertyNames(monthlyAccountState).map(yearMonth => {
        const stateForYearMonth = monthlyAccountState[yearMonth];
        if (stateForYearMonth) {
          return {
            yearMonth,
            accountsValues: Object.getOwnPropertyNames(stateForYearMonth)
              .filter(accountNo => accountNo !== 'lastRefreshed')
              .map(accountNo => {
              return {
                accountNumber: String(accountNo),
                value: stateForYearMonth[Number(accountNo)]??0
              } as AccountValue;
            })
          } as MonthlyAccounts;
        }
        return {
          yearMonth,
          accountsValues: []
        };
      });
      }
    ))
  };

  getMonthlyCashFlowState = (yearMonths: string[]): Observable<MonthlyCashFlow[]> => {
    const callable = this.functions.httpsCallable('getMonthlyCashFlowState');
    return callable({
      yearMonths,
      accessToken: this.localStorageService.getAccessToken()
    }).pipe(map((monthlyCashFlowState: { [yearMonth: string]: { cashIn: number, cashOut: number, result: number, treasury: number } }) => {
      return Object.getOwnPropertyNames(monthlyCashFlowState).map(yearMonth => {
        return {
          yearMonth,
          cashIn: monthlyCashFlowState[yearMonth].cashIn,
          cashOut: monthlyCashFlowState[yearMonth].cashOut,
          result: monthlyCashFlowState[yearMonth].result,
          treasury: monthlyCashFlowState[yearMonth].treasury
        } as MonthlyCashFlow;
      });
    }));
  }
}
